/** 常見支付 provider code（對應 payment 策略） */
export const MERCHANT_CODE_OPTIONS = [
  { value: 'aawalletpayV2', label: 'aawalletpayV2' },
  { value: 'aawalletpay', label: 'aawalletpay' },
];

export { buildCurrencyOptionsFromCoinPayTypes, FALLBACK_CURRENCY_OPTIONS as CURRENCY_TYPE_OPTIONS } from './paymentAssetConstants';

export const ENABLED_FILTER_OPTIONS = [
  { value: '', label: '全部' },
  { value: 'true', label: '啟用' },
  { value: 'false', label: '停用' },
];

export const DEFAULT_MERCHANT_FORM = {
  name: '',
  merchantCode: '',
  merchantId: '',
  currencyType: '',
  image: '',
  url: '',
  gateway: '',
  publicKey: '',
  secretKey: '',
  sort: '0',
  depositOrderLanguage: '',
  orderUrl: '',
  orderQueryUrl: '',
  withdrawalUrl: '',
  withdrawalQueryUrl: '',
  balanceAmountUrl: '',
  notifyUrl: '',
};

export function rowToForm(row) {
  if (!row) {
    return { ...DEFAULT_MERCHANT_FORM };
  }
  return {
    name: row.name ?? '',
    merchantCode: row.merchantCode ?? '',
    merchantId: row.merchantId ?? '',
    currencyType: row.currencyType ?? 'USDT',
    image: row.image ?? '',
    url: row.url ?? '',
    gateway: row.gateway ?? '',
    publicKey: row.publicKey ?? '',
    secretKey: row.secretKey ?? '',
    sort: row.sort != null ? String(row.sort) : '0',
    depositOrderLanguage: row.depositOrderLanguage ?? '',
    orderUrl: row.orderUrl ?? '',
    orderQueryUrl: row.orderQueryUrl ?? '',
    withdrawalUrl: row.withdrawalUrl ?? '',
    withdrawalQueryUrl: row.withdrawalQueryUrl ?? '',
    balanceAmountUrl: row.balanceAmountUrl ?? '',
    notifyUrl: row.notifyUrl ?? '',
  };
}

function parseOptionalNumber(value, fallback = 0) {
  if (value === '' || value == null) {
    return fallback;
  }
  const num = Number(value);
  return Number.isNaN(num) ? fallback : num;
}

function trimOrNull(value) {
  const trimmed = value?.trim();
  return trimmed || null;
}

export function formToPayload(form, editingId) {
  const payload = {
    name: form.name?.trim(),
    merchantCode: form.merchantCode?.trim(),
    merchantId: form.merchantId?.trim(),
    currencyType: form.currencyType?.trim(),
    image: trimOrNull(form.image),
    url: trimOrNull(form.url),
    gateway: trimOrNull(form.gateway),
    publicKey: trimOrNull(form.publicKey),
    secretKey: trimOrNull(form.secretKey),
    sort: parseOptionalNumber(form.sort, 0),
    depositOrderLanguage: trimOrNull(form.depositOrderLanguage),
    orderUrl: trimOrNull(form.orderUrl),
    orderQueryUrl: trimOrNull(form.orderQueryUrl),
    withdrawalUrl: trimOrNull(form.withdrawalUrl),
    withdrawalQueryUrl: trimOrNull(form.withdrawalQueryUrl),
    balanceAmountUrl: trimOrNull(form.balanceAmountUrl),
    notifyUrl: trimOrNull(form.notifyUrl),
  };
  if (editingId != null) {
    payload.id = editingId;
  }
  return payload;
}

export function filterMerchants(records, filters) {
  let list = records || [];
  const name = filters.name?.trim().toLowerCase();
  const merchantCode = filters.merchantCode?.trim().toLowerCase();
  const currencyType = filters.currencyType?.trim().toLowerCase();

  if (name) {
    list = list.filter(
      (row) =>
        row.name?.toLowerCase().includes(name) ||
        row.merchantId?.toLowerCase().includes(name)
    );
  }
  if (merchantCode) {
    list = list.filter((row) => row.merchantCode?.toLowerCase().includes(merchantCode));
  }
  if (currencyType) {
    list = list.filter((row) => row.currencyType?.toLowerCase().includes(currencyType));
  }
  if (filters.isEnabled === 'true') {
    list = list.filter((row) => row.isEnabled === true);
  }
  if (filters.isEnabled === 'false') {
    list = list.filter((row) => row.isEnabled === false);
  }
  return list;
}

export function maskSecret(value) {
  if (!value || value.length <= 8) {
    return value ? '****' : '—';
  }
  return `${value.slice(0, 4)}****${value.slice(-4)}`;
}
